import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Check if fbq already exists
    if ((window as any).fbq) return;
    // Create fbq function
    const fbq = function (...args: any[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    (window as any).fbq = fbq;
    (window as any)._fbq = fbq;
    // Safely inject the script into document.head
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '3070568583125644');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-160">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=3070568583125644&ev=PageView&noscript=1" alt="" data-id="element-161" />
    </noscript>;
}